import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';

const provideAccess = (app) => {
  // eslint-disable-next-line
  if (parent && parent !== window) { // If in an iframe...
    // eslint-disable-next-line
    parent.QuickenGlobal.productSelector.setDispatcher(
      app.dispatch.bind(app)
    );
  }
  window.QuickenGlobal = {
    productSelector: {
      app,
      reset: app.dispatch.bind(app, { type: 'reset' }),
      getState: () => app.state,
    }
  }
}

const onPageChange = (newPageIndex) => {
  // eslint-disable-next-line
  if (parent && parent !== window) { // If in an iframe...
    // eslint-disable-next-line
    parent.QuickenGlobal.productSelector.setPageIndex(newPageIndex);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App ref={(app) => provideAccess(app)} onPageChange={ onPageChange } />
  </React.StrictMode>
);
